import { z } from 'zod'
import { oc } from '@orpc/contract'

/**
 * Two-factor enrolment for a patient Login with no profile yet (PD-1885). Public: the browser
 * holds only the Login id from `auth/2fa/verify`, so the server proves the rest. The `code`
 * pairs with the browser's own PKCE challenge. `CONFLICT` is the duplicate-patient refusal;
 * `SERVICE_UNAVAILABLE` means another new chart for the email is in flight (PD-1930).
 */
export const patientEnrol = oc
  .route({ method: 'POST', path: '/v2/patient/enrol' })
  .errors({
    CONFLICT: {
      data: z.object({ code: z.literal('DUPLICATE_PATIENT'), hasLogin: z.boolean() }),
    },
    SERVICE_UNAVAILABLE: {},
  })
  .input(z.object({ login: z.string().min(1) }))
  .output(z.object({ code: z.string() }))
